(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gemstone-specifications-panel"] && !Shopify.designMode) return;
  try {
    const setupGemstoneTabs = () => {
    document.querySelectorAll('[data-gemstone-tabs]').forEach((tabset) => {
      const tabs = Array.from(tabset.querySelectorAll('[data-gemstone-tab]'));
      const panels = Array.from(tabset.querySelectorAll('[data-gemstone-panel]'));

      const activateTab = (target) => {
        tabs.forEach((tab) => {
          tab.setAttribute('aria-selected', String(tab.dataset.gemstoneTab === target));
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.gemstonePanel !== target;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activateTab(tab.dataset.gemstoneTab));
      });

      tabset.querySelectorAll('[data-gemstone-write-review]').forEach((button) => {
        if (button.dataset.reviewHandlerAttached === 'true') return;

        button.dataset.reviewHandlerAttached = 'true';
        button.addEventListener('click', () => {
          const reviews = button.closest('.gemstone-spec-panel__reviews');
          const judgeMeButton = reviews?.querySelector(
            "[data-testid='write-review-button'], .jm-action-buttons__button"
          );

          judgeMeButton?.click();
        });
      });
    });
  };

  setupGemstoneTabs();
  document.addEventListener('shopify:section:load', setupGemstoneTabs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stone-product-card"] && !Shopify.designMode) return;
  try {
    const wishlistStorageKey = 'raza-gems-wishlist';
  const getStoneWishlist = () => JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
  const setStoneWishlist = (wishlist) => localStorage.setItem(wishlistStorageKey, JSON.stringify(wishlist));

  const syncStoneWishlistButtons = () => {
    const wishlist = getStoneWishlist();

    document.querySelectorAll('[data-stone-wishlist]').forEach((button) => {
      const active = wishlist.some((item) => item.handle === button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-stone-wishlist]');

    if (!button) return;

    const wishlist = getStoneWishlist();
    const product = {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      variantId: button.dataset.productVariantId,
      color: button.dataset.productColor,
      shape: button.dataset.productShape,
      type: button.dataset.productGemstoneType,
      gemstoneType: button.dataset.productGemstoneType,
      productType: button.dataset.productType,
    };
    const existingIndex = wishlist.findIndex((item) => item.handle === product.handle);

    if (existingIndex > -1) {
      wishlist.splice(existingIndex, 1);
    } else {
      wishlist.unshift(product);
    }

    setStoneWishlist(wishlist);
    syncStoneWishlistButtons();
    window.dispatchEvent(new CustomEvent('raza-gems:wishlist-updated', { detail: { count: wishlist.length } }));
  });

  syncStoneWishlistButtons();
  window.addEventListener('raza-gems:wishlist-updated', syncStoneWishlistButtons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stone-product-listing"] && !Shopify.designMode) return;
  try {
    const moneyFormat = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const parseCarat = (value) => {
    const match = String(value || '').match(/[\d.]+/);
    return match ? Number(match[0]) : NaN;
  };
  const normalize = (value) => String(value || '').trim().toLowerCase();
  const handle = (value) => normalize(value).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const initStoneListing = (listing) => {
    if (listing.dataset.stoneListingInitialized === 'true') return;

    listing.dataset.stoneListingInitialized = 'true';

    const items = Array.from(listing.querySelectorAll('[data-stone-item]'));
    const searchInputs = Array.from(listing.querySelectorAll('[data-stone-search]'));
    const count = listing.querySelector('[data-stone-count]');
    const chips = listing.querySelector('[data-stone-chips]');
    const grid = listing.querySelector('[data-stone-grid]');
    const empty = listing.querySelector('[data-stone-empty]');
    const priceMaxRange = listing.querySelector('[data-price-range-max]');
    const priceRangeTrack = listing.querySelector('[data-price-range-track]');
    const priceRangeMinLabel = listing.querySelector('[data-price-range-min-label]');
    const priceRangeMaxLabel = listing.querySelector('[data-price-range-max-label]');
    const priceRangeSelectedLabel = listing.querySelector('[data-price-range-selected-label]');
    const sort = listing.querySelector('[data-stone-sort]');
    const clearButtons = listing.querySelectorAll('[data-stone-clear]');
    const typeRail = listing.querySelector('[data-type-rail]');
    const viewButtons = listing.querySelectorAll('[data-view-mode]');
    const filterDrawer = listing.querySelector('[data-stone-filter-drawer]');
    const filterToggle = listing.querySelector('[data-stone-filter-toggle]');
    const filterCloseButtons = listing.querySelectorAll('[data-stone-filter-close]');
    const mobileMedia = window.matchMedia('(max-width: 900px)');
    let filterToggleReturn = null;

    listing.querySelectorAll('.stone-filter').forEach((filter) => {
      filter.open = true;
      filter.addEventListener('toggle', () => {
        if (!filter.open) filter.open = true;
      });
    });

    const state = {
      search: '',
      types: new Set(),
      shapes: new Set(),
      colors: new Set(),
      carats: new Set(),
      min: null,
      max: null,
      sort: 'featured',
    };

    const closeFilterDrawer = () => {
      listing.classList.remove('is-filter-drawer-open');
      filterToggle?.setAttribute('aria-expanded', 'false');

      if (filterDrawer) {
        filterDrawer.setAttribute('aria-hidden', mobileMedia.matches ? 'true' : 'false');
      }

      document.documentElement.classList.remove('stone-filter-drawer-open');

      if (filterToggleReturn instanceof HTMLElement) {
        filterToggleReturn.focus();
      }
    };

    const openFilterDrawer = () => {
      if (!mobileMedia.matches) return;

      filterToggleReturn = document.activeElement;
      listing.classList.add('is-filter-drawer-open');
      filterToggle?.setAttribute('aria-expanded', 'true');
      filterDrawer?.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('stone-filter-drawer-open');
      filterDrawer?.querySelector('[data-stone-filter-close]')?.focus();
    };

    const prices = items.map((item) => Number(item.dataset.price || 0) / 100).filter((price) => Number.isFinite(price) && price >= 0);
    const minPrice = prices.length ? Math.min(...prices) : 0;
    const highestPrice = prices.length ? Math.max(...prices) : 0;
    const maxPrice = highestPrice;
    const formatPrice = (price) => `Rs. ${moneyFormat.format(Number(price) || 0)}`;

    const syncPriceRangeUi = (max) => {
      if (!priceMaxRange || !priceRangeTrack) return;
      const total = Math.max(maxPrice - minPrice, 1);
      const maxPercent = Math.max(0, Math.min(((max - minPrice) / total) * 100, 100));

      priceMaxRange.value = String(max);
      priceMaxRange.style.setProperty('--catalog-price-progress', `${maxPercent}%`);
      if (priceRangeMinLabel) priceRangeMinLabel.textContent = formatPrice(minPrice);
      if (priceRangeMaxLabel) priceRangeMaxLabel.textContent = formatPrice(maxPrice);
      if (priceRangeSelectedLabel) priceRangeSelectedLabel.textContent = formatPrice(max);
    };

    if (priceMaxRange) {
      priceMaxRange.min = minPrice;
      priceMaxRange.max = maxPrice;
      priceMaxRange.step = 0.01;
      syncPriceRangeUi(maxPrice);
    }

    const makeMap = (attr, labelAttr = attr) => {
      const map = new Map();
      items.forEach((item) => {
        const key = item.dataset[attr];
        const label = item.dataset[labelAttr];
        if (!key || !label) return;
        const entry = map.get(key) || { key, label, count: 0, image: item.dataset.image || '' };
        entry.count += 1;
        if (!entry.image && item.dataset.image) entry.image = item.dataset.image;
        map.set(key, entry);
      });
      return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label));
    };

    const typeOptions = makeMap('typeKey', 'type');
    const shapeOptions = makeMap('shapeKey', 'shape');
    const colorOptions = makeMap('colorKey', 'color');
    const caratRanges = [
      { key: '0-1', label: '0-1 Carat', min: 0, max: 1 },
      { key: '1-2', label: '1-2 Carats', min: 1, max: 2 },
      { key: '2-3', label: '2-3 Carats', min: 2, max: 3 },
      { key: '3-4', label: '3-4 Carats', min: 3, max: 4 },
      { key: '4-5', label: '4-5 Carats', min: 4, max: 5 },
      { key: '5-6', label: '5-6 Carats', min: 5, max: 6 },
      { key: '6-10', label: '6-10 Carats', min: 6, max: 10 },
      { key: '10-plus', label: '10+ Carats', min: 10, max: Infinity },
    ].map((range) => ({
      ...range,
      count: items.filter((item) => {
        const carat = parseCarat(item.dataset.carat);
        return !Number.isNaN(carat) && carat >= range.min && carat < range.max;
      }).length,
    }));

    const renderCheckboxes = (target, options, type) => {
      const container = listing.querySelector(`[data-filter-options="${target}"]`);
      if (!container) return;
      container.innerHTML = options.map((option) => `
        <label class="stone-filter__option" data-option-label="${option.label.toLowerCase()}">
          <input type="checkbox" value="${option.key}" data-filter-check="${type}">
          <span></span>
          <em>${option.label} (${option.count})</em>
        </label>
      `).join('');
    };

    renderCheckboxes('type', typeOptions, 'type');
    renderCheckboxes('shape', shapeOptions, 'shape');
    renderCheckboxes('color', colorOptions, 'color');
    renderCheckboxes('carat', caratRanges, 'carat');

    if (typeRail) {
      typeRail.innerHTML = [
        `<button type="button" class="is-active" data-type-tile="">All</button>`,
        ...typeOptions.map((option) => `
          <button type="button" data-type-tile="${option.key}">
            ${option.image ? `<img src="${option.image}" alt="">` : ''}
            <span>${option.label}</span>
          </button>
        `),
      ].join('');
    }

    const clampPrices = () => {
      let max = Number(priceMaxRange?.value || maxPrice);
      max = Math.max(minPrice, Math.min(max, maxPrice));
      state.min = minPrice;
      state.max = max;
      syncPriceRangeUi(max);
    };

    const matchesCarat = (item) => {
      if (!state.carats.size) return true;
      const carat = parseCarat(item.dataset.carat);
      if (Number.isNaN(carat)) return false;
      return Array.from(state.carats).some((key) => {
        const range = caratRanges.find((entry) => entry.key === key);
        return range && carat >= range.min && carat < range.max;
      });
    };

    const apply = () => {
      clampPrices();
      let visible = items.filter((item) => {
        const price = Number(item.dataset.price || 0) / 100;
        const title = normalize(item.dataset.title);
        return (!state.search || title.startsWith(state.search))
          && (!state.types.size || state.types.has(item.dataset.typeKey))
          && (!state.shapes.size || state.shapes.has(item.dataset.shapeKey))
          && (!state.colors.size || state.colors.has(item.dataset.colorKey))
          && matchesCarat(item)
          && price >= state.min
          && price <= state.max;
      });

      visible.sort((a, b) => {
        if (state.sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (state.sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (state.sort === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
        if (state.sort === 'title-desc') return b.dataset.title.localeCompare(a.dataset.title);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });

      items.forEach((item) => { item.hidden = true; });
      visible.forEach((item) => {
        item.hidden = false;
        grid.appendChild(item);
      });

      count.textContent = `Showing ${visible.length} of ${items.length} products`;
      empty.hidden = visible.length > 0;

      const chipValues = [
        ...typeOptions.filter((option) => state.types.has(option.key)).map((option) => option.label),
        ...shapeOptions.filter((option) => state.shapes.has(option.key)).map((option) => option.label),
        ...colorOptions.filter((option) => state.colors.has(option.key)).map((option) => option.label),
        ...caratRanges.filter((option) => state.carats.has(option.key)).map((option) => option.label),
      ];
      chips.innerHTML = chipValues.map((label) => `<span>${label}</span>`).join('');
    };

    listing.addEventListener('change', (event) => {
      const checkbox = event.target.closest('[data-filter-check]');
      if (checkbox) {
        const targetSet = checkbox.dataset.filterCheck === 'type' ? state.types : checkbox.dataset.filterCheck === 'shape' ? state.shapes : checkbox.dataset.filterCheck === 'color' ? state.colors : state.carats;
        checkbox.checked ? targetSet.add(checkbox.value) : targetSet.delete(checkbox.value);
      }
      if (event.target === sort) state.sort = sort.value;
      apply();
    });

    listing.addEventListener('input', (event) => {
      const searchInput = event.target.closest('[data-stone-search]');
      if (searchInput) {
        state.search = normalize(searchInput.value);
        searchInputs.forEach((input) => {
          if (input !== searchInput) input.value = searchInput.value;
        });
      }
      if (event.target === priceMaxRange) syncPriceRangeUi(Number(priceMaxRange.value || maxPrice));
      apply();
    });

    typeRail?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-type-tile]');
      if (!button) return;
      state.types.clear();
      if (button.dataset.typeTile) state.types.add(button.dataset.typeTile);
      listing.querySelectorAll('[data-type-tile]').forEach((tile) => tile.classList.toggle('is-active', tile === button));
      listing.querySelectorAll('[data-filter-check="type"]').forEach((checkbox) => {
        checkbox.checked = state.types.has(checkbox.value);
      });
      apply();
    });

    clearButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.search = '';
        state.types.clear();
        state.shapes.clear();
        state.colors.clear();
        state.carats.clear();
        state.sort = 'price-asc';
        searchInputs.forEach((input) => { input.value = ''; });
        sort.value = 'price-asc';
        if (priceMaxRange) priceMaxRange.value = maxPrice;
        syncPriceRangeUi(maxPrice);
        listing.querySelectorAll('[data-filter-check]').forEach((checkbox) => { checkbox.checked = false; });
        listing.querySelectorAll('[data-type-tile]').forEach((tile, index) => tile.classList.toggle('is-active', index === 0));
        apply();
      });
    });

    viewButtons.forEach((button) => {
      button.addEventListener('click', () => {
        viewButtons.forEach((control) => control.classList.toggle('is-active', control === button));
        grid.classList.toggle('stone-listing__grid--list', button.dataset.viewMode === 'list');
      });
    });

    filterToggle?.addEventListener('click', openFilterDrawer);
    filterCloseButtons.forEach((button) => button.addEventListener('click', closeFilterDrawer));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && listing.classList.contains('is-filter-drawer-open')) {
        closeFilterDrawer();
      }
    });

    mobileMedia.addEventListener('change', () => {
      if (mobileMedia.matches) {
        filterDrawer?.setAttribute('aria-hidden', listing.classList.contains('is-filter-drawer-open') ? 'false' : 'true');
      } else {
        closeFilterDrawer();
        filterDrawer?.setAttribute('aria-hidden', 'false');
      }
    });

    if (filterDrawer) {
      filterDrawer.setAttribute('aria-hidden', mobileMedia.matches ? 'true' : 'false');
    }

    apply();
  };

  const initStoneListings = (root = document) => {
    if (root.matches?.('[data-stone-listing]')) {
      initStoneListing(root);
    }

    root.querySelectorAll('[data-stone-listing]').forEach(initStoneListing);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStoneListings(), { once: true });
  } else {
    initStoneListings();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initStoneListings(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-content"] && !Shopify.designMode) return;
  try {
    const wishlistPage = document.querySelector('[data-wishlist-page]');
  const getWishlistItems = () => JSON.parse(localStorage.getItem('raza-gems-wishlist') || '[]');
  const setWishlistItems = (wishlist) => localStorage.setItem('raza-gems-wishlist', JSON.stringify(wishlist));

  let wishlistDetailsFrame = 0;
  const fitWishlistDetails = () => {
    if (!wishlistPage?.isConnected) return;

    const cards = Array.from(wishlistPage.querySelectorAll('[data-wishlist-card]:not([hidden])'));
    for (const card of cards) {
      for (const row of card.querySelectorAll('.wishlist-card__detail')) row.hidden = false;
    }

    const visibility = cards.flatMap((card) => {
      const media = card.querySelector('.wishlist-card__media');
      if (!media || media.getBoundingClientRect().height === 0) return [];
      const bottom = media.getBoundingClientRect().bottom;
      return Array.from(card.querySelectorAll('.wishlist-card__detail'), (row) => ({
        row,
        hidden: row.getBoundingClientRect().bottom > bottom + 0.5,
      }));
    });
    for (const { row, hidden } of visibility) row.hidden = hidden;
  };

  const scheduleWishlistDetails = () => {
    cancelAnimationFrame(wishlistDetailsFrame);
    wishlistDetailsFrame = requestAnimationFrame(fitWishlistDetails);
  };

  const wishlistDetailsObserver = new ResizeObserver(scheduleWishlistDetails);
  if (wishlistPage) {
    for (const element of wishlistPage.querySelectorAll('.wishlist-card__media, .wishlist-card__header')) {
      wishlistDetailsObserver.observe(element);
    }
    const onWishlistSectionUnload = (event) => {
      if (!(event.target instanceof Element) || !event.target.contains(wishlistPage)) return;
      wishlistDetailsObserver.disconnect();
      cancelAnimationFrame(wishlistDetailsFrame);
      document.removeEventListener('shopify:section:unload', onWishlistSectionUnload);
    };
    document.addEventListener('shopify:section:unload', onWishlistSectionUnload);
  }

  const renderRazaGemsWishlist = () => {
    if (!wishlistPage) return;

    const grid = wishlistPage.querySelector('[data-wishlist-grid]');
    const empty = wishlistPage.querySelector('[data-wishlist-empty]');
    const summary = wishlistPage.querySelector('[data-wishlist-summary]');
    const count = wishlistPage.querySelector('[data-wishlist-count]');
    if (!grid || !empty || !summary) return;

    const wishlist = getWishlistItems().filter((item) => item.handle);
    const cards = Array.from(grid.querySelectorAll('[data-wishlist-card]'));
    const cardByHandle = new Map(cards.map((card) => [card.dataset.productHandle, card]));
    let visibleCount = 0;

    cards.forEach((card) => {
      card.hidden = true;
    });

    wishlist.forEach((item) => {
      const card = cardByHandle.get(item.handle);
      if (!card) return;

      card.hidden = false;
      grid.appendChild(card);
      visibleCount += 1;
    });

    grid.hidden = visibleCount === 0;
    summary.hidden = visibleCount === 0;
    empty.hidden = visibleCount > 0;
    scheduleWishlistDetails();

    if (count) {
      count.textContent =
        visibleCount === 1 ? grid.dataset.countOne : grid.dataset.countOther.replace('COUNT', String(visibleCount));
    }
  };

  document.addEventListener('click', (event) => {
    if (!wishlistPage) return;

    const removeButton = event.target.closest('[data-wishlist-remove]');

    if (removeButton) {
      const wishlist = getWishlistItems().filter((product) => product.handle !== removeButton.dataset.wishlistRemove);
      setWishlistItems(wishlist);
      renderRazaGemsWishlist();
      window.dispatchEvent(new CustomEvent('raza-gems:wishlist-updated', { detail: { count: wishlist.length } }));
    }
  });

  renderRazaGemsWishlist();
  window.addEventListener('raza-gems:wishlist-updated', renderRazaGemsWishlist);
  window.addEventListener('storage', renderRazaGemsWishlist);
  } catch(e) { console.error(e); }
})();

})();
